import * as filters from '../filters';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.globalProperties.$filters = {
    ...filters,
  };
});
